class TestimonialsSection extends HTMLElement {
  constructor() {
    super();
    this.swiperContainer = this.querySelector('.swiper');
  }

  connectedCallback() {
    if (!this.swiperContainer) return;
    this.initSwiper();

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        if (this.closest('.shopify-section') && event.detail.sectionId === this.closest('.shopify-section').id.replace('shopify-section-', '')) {
          this.initSwiper();
        }
      });
    }
  }

  initSwiper() {
    if (this.swiper) {
      this.swiper.destroy();
    }

    const autoRotate = this.swiperContainer.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(this.swiperContainer.dataset.autoplayDelay) || 5000;
    const transition = this.swiperContainer.dataset.transition;
    const paginationStyle = this.swiperContainer.dataset.pagination;

    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      effect: transition === 'fade' ? 'fade' : 'slide',
      fadeEffect: transition === 'fade' ? { crossFade: true } : undefined,
    };

    if (autoRotate) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    if (paginationStyle === 'dots') {
      swiperOptions.pagination = {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      };
    } else if (paginationStyle === 'arrows') {
      swiperOptions.navigation = {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      };
    }

    if (typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(this.swiperContainer, swiperOptions);
    } else {
      console.error('Swiper is not defined. Ensure swiper-bundle.min.js is loaded.');
    }
  }
}

customElements.define('testimonials-section', TestimonialsSection);
